import { Color } from "../../logic/enums.ts";

const RaindropProgressBar = ({
  color = Color.Raindrop,
  proportion = 0.3,
  className = "",
}) => {
  const progressPercentage = 10 + proportion * 90;

  let tailwindBackgroundColor = "bg-color-raindrop-primary";
  let tailwindBorderColor = "border-color-raindrop-secondary";

  if (color === Color.Blue) {
    tailwindBackgroundColor = "bg-blue-600";
    tailwindBorderColor = "border-color-background-primary";
  }

  if (color === Color.Bronze) {
    tailwindBackgroundColor = "bg-amber-600";
    tailwindBorderColor = "border-color-background-primary";
  }

  if (color === Color.Silver) {
    tailwindBackgroundColor = "bg-slate-500";
    tailwindBorderColor = "border-color-background-primary";
  }

  if (color === Color.Gold) {
    tailwindBackgroundColor = "bg-amber-400";
    tailwindBorderColor = "border-color-background-primary";
  }

  return (
    <div
      className={`flex flex-col w-full dark:bg-color-dark-background-tertiary bg-color-background-tertiary rounded-full justify-center relative ${className}`}
    >
      <div
        className={`flex h-6 rounded-full w-full transition-all border-2 ${tailwindBorderColor} ${tailwindBackgroundColor}`}
        style={{ width: `${progressPercentage}%` }}
      />
      <div
        className="flex h-[6px] ml-3 translate-y-[3px] rounded-full w-full transition-all absolute bg-white opacity-30 "
        style={{ width: `${progressPercentage * 0.5}%` }}
      />
    </div>
  );
};

export default RaindropProgressBar;
